import { createActions, } from 'redux-actions';

export default createActions({
  ROUND: {
    ADD_WINNING_BALL: null,
  },
});
